/**
 * Country display names for the dynamic CTA label ("Ir a DGO {country}").
 * Keyed by locale prefix. Country names are identical across ES variants,
 * so per-language (es/pt) is enough — no per-locale matrix needed.
 */
export const COUNTRY_NAME_BY_LOCALE: Record<string, string> = {
  ar: 'Argentina',
  uy: 'Uruguay',
  co: 'Colombia',
  cl: 'Chile',
  ec: 'Ecuador',
  pe: 'Perú',
  mx: 'México',
  br: 'Brasil'
}
